import { $get } from '../base'

export const getNumber = () =>
  $get('/api/home_page/project_count/', {
    p_type: 2,
  })
